import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRhinocerosComponent } from './simple-icons-rhinoceros.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRhinocerosComponent ],
    exports:      [ SimpleIconsRhinocerosComponent ],
    bootstrap:    []
})
export class SimpleIconsRhinocerosModule {}
